/* xo, Fetti Sample Program application */
(function () {
  var API_URL = window.XOFETTI_SAMPLE_PROGRAM_API_URL || 'https://story-inventory.com/api/xofetti/sample-program/applications';
  var REQUIRED_ACCEPTANCE_PHRASE = 'I agree';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function setRequired(input, required) {
    if (!input) return;
    input.required = required;
    if (!required) input.value = '';
  }

  function setMessage(el, type, text) {
    if (!el) return;
    el.className = 'sample-program-message sample-program-message--' + type;
    el.textContent = text;
    el.hidden = false;
  }

  function clearMessage(el) {
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
    el.className = 'sample-program-message';
  }

  function showThankYou(dialog) {
    if (!dialog) return;
    dialog.hidden = false;
    document.body.classList.add('sample-program-modal-open');
    dialog.focus();
  }

  function hideThankYou(dialog) {
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove('sample-program-modal-open');
  }

  function validationMessage(field) {
    var label = field.closest('.sample-program-field');
    var name = label ? label.querySelector('span') : null;
    var labelText = name ? name.textContent.replace(/\s+/g, ' ').trim() : 'This field';
    return labelText + ' needs a quick look.';
  }

  function firstInvalidMessage(form) {
    var invalid = form.querySelector(':invalid');
    if (!invalid) return '';
    return validationMessage(invalid);
  }

  function payloadFromForm(form) {
    var data = new FormData(form);
    return {
      first_name: String(data.get('first_name') || '').trim(),
      last_name: String(data.get('last_name') || '').trim(),
      shipping_country: String(data.get('shipping_country') || '').trim(),
      shipping_address: String(data.get('shipping_address') || '').trim(),
      shipping_address_2: String(data.get('shipping_address_2') || '').trim(),
      shipping_city: String(data.get('shipping_city') || '').trim(),
      shipping_state: String(data.get('shipping_state') || '').trim(),
      shipping_zip: String(data.get('shipping_zip') || '').trim(),
      email: String(data.get('email') || '').trim(),
      instagram_url: String(data.get('instagram_url') || '').trim(),
      party_type: String(data.get('party_type') || '').trim(),
      zodiac_sign: String(data.get('zodiac_sign') || '').trim(),
      bachelorette_bash_date: String(data.get('bachelorette_bash_date') || '').trim(),
      program_fit_notes: String(data.get('program_fit_notes') || '').trim(),
      agreed_to_review_and_photo: data.get('agreed_to_review_and_photo') === 'on',
      agreed_to_photo_rights: data.get('agreed_to_photo_rights') === 'on',
      marketing_email_opt_in: data.get('marketing_email_opt_in') === 'on',
      source_url: window.location.href
    };
  }

  function updateConditionalFields(form) {
    var partyType = qs('#sample-party-type', form);
    var birthday = qs('#sample-birthday-fields', form);
    var bachelorette = qs('#sample-bachelorette-fields', form);
    var zodiac = qs('[name="zodiac_sign"]', form);
    var bashDate = qs('[name="bachelorette_bash_date"]', form);
    var value = partyType ? partyType.value : '';

    if (birthday) birthday.hidden = value !== 'Birthday';
    if (bachelorette) bachelorette.hidden = value !== 'Bachelorette';

    setRequired(zodiac, value === 'Birthday');
    setRequired(bashDate, value === 'Bachelorette');
  }

  function validateAcceptancePhrase(form) {
    var reviewAgreement = qs('[name="agreed_to_review_and_photo"]', form);
    var phrase = qs('[name="review_acceptance_phrase"]', form);

    if (!reviewAgreement || !phrase || !reviewAgreement.checked) {
      if (phrase) phrase.setCustomValidity('');
      return true;
    }

    var isValid = phrase.value.trim().toLowerCase() === REQUIRED_ACCEPTANCE_PHRASE.toLowerCase();
    phrase.setCustomValidity(isValid ? '' : 'Please enter the phrase: I agree');
    return isValid;
  }

  function updateAcceptancePhrase(form) {
    var reviewAgreement = qs('[name="agreed_to_review_and_photo"]', form);
    var phraseWrap = qs('#sample-program-acceptance-phrase', form);
    var phrase = qs('[name="review_acceptance_phrase"]', form);
    var shouldShow = !!(reviewAgreement && reviewAgreement.checked);

    if (phraseWrap) phraseWrap.hidden = !shouldShow;
    if (phrase) {
      phrase.required = shouldShow;
      if (!shouldShow) {
        phrase.value = '';
      }
    }

    validateAcceptancePhrase(form);
  }

  function init() {
    var form = qs('#sample-program-form');
    if (!form) return;

    var partyType = qs('#sample-party-type', form);
    var message = qs('#sample-program-message');
    var submit = qs('#sample-program-submit');
    var thankYou = qs('#sample-program-thank-you');
    var thankYouClose = qs('.sample-program-thank-you__close', thankYou);
    var reviewAgreement = qs('[name="agreed_to_review_and_photo"]', form);
    var phrase = qs('[name="review_acceptance_phrase"]', form);

    updateConditionalFields(form);
    updateAcceptancePhrase(form);

    if (partyType) {
      partyType.addEventListener('change', function () {
        updateConditionalFields(form);
        clearMessage(message);
      });
    }

    form.addEventListener('input', function () {
      validateAcceptancePhrase(form);
      clearMessage(message);
    });

    if (reviewAgreement) {
      reviewAgreement.addEventListener('change', function () {
        updateAcceptancePhrase(form);
        clearMessage(message);
      });
    }

    if (phrase) {
      phrase.addEventListener('input', function () {
        validateAcceptancePhrase(form);
      });
    }

    if (thankYouClose) {
      thankYouClose.addEventListener('click', function () {
        hideThankYou(thankYou);
      });
    }

    if (thankYou) {
      thankYou.addEventListener('click', function (event) {
        if (event.target === thankYou) {
          hideThankYou(thankYou);
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && thankYou && !thankYou.hidden) {
        hideThankYou(thankYou);
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      updateConditionalFields(form);
      updateAcceptancePhrase(form);
      clearMessage(message);

      if (!form.checkValidity()) {
        setMessage(message, 'error', firstInvalidMessage(form) || 'Please complete the required fields.');
        form.reportValidity();
        return;
      }

      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Submitting...';
      }

      fetch(API_URL, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payloadFromForm(form))
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            if (!response.ok) {
              var errors = body && body.errors ? Object.keys(body.errors) : [];
              var field = errors.length ? errors[0].replace(/_/g, ' ') : '';
              throw new Error(field ? 'Please check ' + field + '.' : 'We could not submit this application yet.');
            }
            return body;
          });
        })
        .then(function () {
          form.reset();
          updateConditionalFields(form);
          updateAcceptancePhrase(form);
          showThankYou(thankYou);
        })
        .catch(function (error) {
          setMessage(message, 'error', error && error.message ? error.message : 'We could not submit this application yet.');
        })
        .finally(function () {
          if (submit) {
            submit.disabled = false;
            submit.textContent = 'Submit Application';
          }
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
